import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: "map",
    style: _normalizeStyle(_ctx.isMobile ? 'width: 96vw;' : '')
  }, [
    _createElementVNode("div", {
      id: "mapContainer",
      style: _normalizeStyle(
                _ctx.isMobile ? 'height: calc(100vh - 330px); width: 100%' : 'height: 800px; width: 100%'
            ),
      ref: "hereMap"
    }, null, 4)
  ], 4))
}